import { Button } from '@chakra-ui/react';
import { Dialog } from '@halo/ui-react';
import type { ReactNode } from 'react';
import { ButtonGray, ConfirmDialog } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

export interface FooterProps {
  selected: any[];
  onOK: (selected: any[], payload?: any) => Promise<void>;
  cancelText: ReactNode;
  okText: ReactNode;
  otherButton?: ReactNode;
  okConfirm?: boolean;
  confirmText?: string;
}

const Footer = ({
  selected,
  onOK,
  cancelText,
  okText,
  otherButton,
  okConfirm = false,
  confirmText,
}: FooterProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <Dialog.Footer>
      {cancelText && (
        <Dialog.ActionTrigger asChild>
          <ButtonGray borderRadius="xl">{cancelText}</ButtonGray>
        </Dialog.ActionTrigger>
      )}
      {okConfirm ? (
        <>
          <Button
            disabled={selected.length === 0 || isLoading}
            borderRadius="xl"
            onClick={() => setConfirmOpen(true)}
          >
            {okText}
          </Button>
          <ConfirmDialog
            open={confirmOpen}
            onClose={() => setConfirmOpen(false)}
            title={confirmText}
            okText={t('buttons.confirm')}
            contentProps={{
              w: '428px',
            }}
            titleProps={{
              truncate: false,
            }}
            onOk={async () => {
              setIsLoading(true);
              await onOK(selected).finally(() => {
                setIsLoading(false);
              });
              setConfirmOpen(false);
            }}
            okButtonProps={{
              loading: isLoading,
            }}
          />
        </>
      ) : (
        <Button
          disabled={selected.length === 0 || isLoading}
          borderRadius="xl"
          onClick={async () => {
            setIsLoading(true);
            await onOK(selected).finally(() => {
              setIsLoading(false);
            });
          }}
        >
          {okText}
        </Button>
      )}
      {otherButton && otherButton}
    </Dialog.Footer>
  );
};

export { Footer };
